// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CreativeSvg from '@rsuite/icon-font/lib/application/Creative';
var Creative = createSvgIcon({
  as: CreativeSvg,
  ariaLabel: 'creative',
  category: 'application',
  displayName: 'Creative'
});
export default Creative;